import parsePhoneNumber from 'libphonenumber-js';

const phoneNumberIsValid = (phoneNumber: string) => {
  const phone = parsePhoneNumber(phoneNumber);
  return phone?.isValid() || false;
};

export default phoneNumberIsValid;
